export var VIEWS = {
  UPLOAD: 'upload',
  DETAILS: 'details',
  PROGRESS: 'progress',
  CONFIRMATION: 'confirmation',
  REPLACE: 'replace'
};

// Asset content type is used to show the different types of asset modals we have
// It is derived from the fileformat and content type of an upload
// See also getAssetContentType
export var ASSET_CONTENT_TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
  WEBLINK: 'web',
  MICROSITE: 'zip',
  SCORM: 'scorm',
  FILE: 'file',
  //  plain zip files
  DOCUMENT: 'document',
  // files with custom types such as spreadsheet, pdf, msword, text, presentation
  ASSET: 'asset' // fallback for any assets we can't categorise
};